import RoundedButton2 from './RoundedButton2.js';
import { Colors } from '../consts/Colors.js';

export default class Popup extends Phaser.GameObjects.Container {
    constructor(scene, text, centerX, consi) {
        super(scene, 0, 0, []);

        scene.add.existing(this);
        this.scene = scene;
        this.text = text;
        let popupHeight = 452;
        let textY = 570;
        let btnY = 700;
        if (!consi) {
            popupHeight = 300;
            textY = 500;
            btnY = 620;
        }

        this.introBack = this.scene.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.DarkBlue, 0.5).setOrigin(0, 0);
        this.add(this.introBack);
        this.intoPopUp = this.scene.add.rexRoundRectangle(centerX, 539, 1004, popupHeight, 47, Colors.Elmt.White).setOrigin(0.5);
        this.add(this.intoPopUp);
        if (consi) {

            let cons = {
                text: 'Vous allez devoir reconstituer en quatre étapes le schéma final de la vidéo sur la Trésorerie nette, le Fonds de Roulement et le Besoin en Fonds de Roulement.',
                config: { size: '32px', fontFamily: 'MassiliaBold', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 924 }
            }
            this.introConsigne = this.scene.createTextElement(centerX, 415, cons)
            this.add(this.introConsigne);
        }
        let titre = {
            text: this.text,
            config: { size: '32px', fontFamily: 'MassiliaMediumOblique', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 924 }
        }
        this.introTitre = this.scene.createTextElement(centerX, textY, titre)
        this.add(this.introTitre);
        this.introBtn = new RoundedButton2(this.scene, centerX, btnY, 212, "Commencer", Colors.Text.White, Colors.Elmt.DarkBlue);
        this.add(this.introBtn);
        // this.introBtn.setClickFunction(() => {
        //     // this.scene.launchGame()
        //     this.destroy()
        // })
    }
}